export enum TextType {
  H1,
  H2,
  H3,
  H4,
  H4bold,
  H5,
  H5bold,
  H6,
  P1,
  P2,
  strong,
  LI,
  UL,
  OL,
}
export enum TextSize {
  default,
  large,
}
export enum TextSpacing {
  default,
  large,
}
export enum TextKerning {
  default,
  large,
}

export interface IProps {
  type?: TextType;
  children: any[];
  size?: TextSize;
  color?: string;
  rowSpacing?: TextSpacing;
  kerning?: TextKerning;
  withContainer?: boolean;
}
export interface IStyled {
  type: TextType;
  size: TextSize;
  rowSpacing: TextSpacing;
  kerning: TextKerning;
}
